module.exports = __webpack_public_path__ + "d95c1be7faa7373a61839320cd9e027f.MP3";